export default __webpack_public_path__ + "static/media/image1pro7.c69c6a19.jpeg";